import axios, { AxiosInstance } from 'axios';
import { ENV } from '../config/env';
import { setupRequestInterceptor } from './httpMethods/requestInterceptor';
import { setupResponseInterceptor } from './httpMethods/responseInterceptor';

const API_BASE_URL = `${ENV.VITE_API_URL}${ENV.VITE_API_BASE_PATH || '/api/v1'}`;

const httpService: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
  withCredentials: true,
});

setupRequestInterceptor(httpService);
setupResponseInterceptor(httpService);

export default httpService;
